import React from 'react';
//*MUI
import { Box, Modal } from '@mui/material';
//*files
import cssClasses from "./ViewUnitCostModal.module.css";
import Button from '../../../Subcomponents/Button';
import Close from '../../../Components/Icons/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: 'fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function ViewUnitCostModal({ open, handleClose, allotment }) {
  console.log("lll", allotment)
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>Summary</Box>
                </Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box width={'100%'} height={'49%'} overflow={'auto'}>
            <Box paddingX={"3rem"} backgroundColor={"#F9FAFB"}>
              <div style={{ width: "100%", height: "100%", color: "#515A6B", fontWeight: "600", fontSize: "1.6rem", lineHeight: "2.6rem" }}>
                <div className={cssClasses.ThirdDivRow}>
                  <span>Agreement Value</span>
                  <span>{allotment?.unitcost?.bsp ? "₹" + numberWithCommas(allotment?.unitcost?.bsp) : "NA"}</span>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <span>SDR </span>
                  <span>{allotment.unitcost?.sdr ? "₹" + numberWithCommas(allotment.unitcost?.sdr) : "NA"}</span>
                </div>
                <div className={cssClasses.ThirdDivRow}>
                  <span>GST </span>
                  <span>{allotment.unitcost?.gst ? "₹" + numberWithCommas(allotment.unitcost?.gst) : "NA"}</span>
                </div>
                <div className={cssClasses.ThirdDivRow}>
                  <span>Unit Cost </span>
                  <span>{allotment.unitcost?.total ? "₹" + numberWithCommas(allotment.unitcost?.total) : "NA"}</span>
                </div>
              </div>
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    color: "#fff",
                    backgroundColor: "#1570EF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={'Close'}
                  clicked={handleClose}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ViewUnitCostModal;


function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}
